__turbopack_context__.v({
  "copy": "_5gnAVq_copy",
  "copy-text": "_5gnAVq_copy-text",
  "link-container": "_5gnAVq_link-container",
  "share-container": "_5gnAVq_share-container",
  "share-giveaway": "_5gnAVq_share-giveaway",
  "share-links-container": "_5gnAVq_share-links-container",
  "title": "_5gnAVq_title",
});
